import type { BreadcrumbTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const breadcrumbDark: BreadcrumbTheme = {
  name: 'Breadcrumb',
  common: commonDark,
  self
}

export default breadcrumbDark
